<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <v-toolbar-title class="headline text-uppercase text-left">
          <span class="font-weight-bold">{{ $t('Order') }} {{ order.orderName }}</span>
          <h6 class="font-weight-light">
            {{ $t('Submitted by') }} {{ order.fullName }} {{ $t('on') }}
            {{ order.dateCreated | formatDate }}
          </h6>
          <v-alert type="success">{{
            $t('You have successfully submitted a return order for the following products')
          }}</v-alert>
        </v-toolbar-title>
        <v-app>
          <v-data-table :headers="headers" :locale="'ro-RO'" :items="this.selectedProducts"></v-data-table>
          <v-flex text-left xs12 class="py-5">
            <h3 class="font-weight-light my-5">
              {{ $t('The request will be processed') }}
            </h3>
            <v-btn color="dark" :dark="true" @click="goBack">{{ $t('HOME') }}</v-btn>
          </v-flex>
        </v-app>
      </v-flex>
    </v-layout>
    <v-overlay :value="overlay" :color="'white'">
      <v-progress-circular indeterminate size="64" :color="'black'"></v-progress-circular>
    </v-overlay>
    <div v-if="themeJson.name === 'custom'">
      <div v-html="styles"></div>
    </div>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
export default {
  data: vm => ({
    overlay: false,
    styles: '',
    headers: [
      { text: vm.$t('Product name'), value: 'name' },
      { text: vm.$t('Quantity'), value: 'quantity' },
      { text: vm.$t('Color'), value: 'variant' },
    ],
  }),
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 1000);
    },
  },
  computed: {
    ...mapGetters(['order', 'selectedProducts']),
    ...mapState(['themeJson'])
  },
  mounted() {
    window.scrollTo(0, 0);
    this.overlay = true;
    this.verifyOrder();
  },
  created() {
    this.styles = this.getStyles();
  },
  methods: {
    getStyles() {
      const theme = this.themeJson;
      return `<style> 
      
body.theme-custom .v-application {
    background-color: ${theme.backgroundColor} !important;
}

body.theme-custom .container .font-weight-light {
      color: ${theme.textColor} !important;
}

body.theme-custom .v-btn.v-btn--has-bg:not(.btn-anulat):not(.btn-return):not(.v-btn--back):not(.v-btn--disabled):not(.v-btn--return):not(.btn-change) {
  background-color: ${theme.cancelBtnColor} !important;
  color: ${theme.btnTextColor} !important;
}

body.theme-custom .theme--light.v-data-table {
      background-color: ${theme.backgroundColor} !important;
      color: ${theme.textColor} !important;
}

body.theme-custom .container .v-data-table__wrapper tbody tr td {
      background: ${theme.inputBackgroundColor} !important;
}
body.theme-custom .container .v-data-table__wrapper table thead tr th{
      color: ${theme.textColor} !important;
}

body.theme-custom .container .v-toolbar__title {
      color: ${theme.textColor} !important;
}

body.theme-custom .v-application .error--text {
      color: #ff5252 !important;
}

body.theme-custom .dialog .v-card__title {
      color: ${theme.textColor} !important;
}

body.theme-custom .dialog .product-wrapper {
      background-color: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .dialog .product-wrapper .product {
      color: ${theme.textColor} !important;
}

body.theme-custom .dialog .product-wrapper .product-variant .product-variant-details {
      color: ${theme.textColor} !important;
}

body.theme-custom .dialog .btn-anulat {
      background-color: ${theme.cancelBtnColor} !important;
}

body.theme-custom .dialog .btn-return {
      background-color: ${theme.sendBtnColor} !important;
}

body.theme-custom .dialog .product-wrapper .product-variant .product-variant-details .float-price {
      box-shadow: unset !important;
}

body.theme-custom .dialog .product-wrapper .product-variant {
      background-color: ${theme.backgroundColor} !important;
}

body.theme-custom .v-label {
      color: ${theme.textColor} !important;
}

body.theme-custom .dialog .v-sheet.v-alert {
      background-color: ${theme.inputBackgroundColor} !important;
      color: ${theme.textColor} !important;
}

body.theme-custom .container--fluid .v-subheader {
      color: ${theme.textColor} !important;
}

body.theme-custom .close-icon path{
    fill: ${theme.textColor};
    
}

body.theme-custom .container .v-select:hover .v-input__slot:before {
      border-color: ${theme.selectBorderColor} !important;
}

body.theme-custom .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
      border-color: ${theme.selectBorderColor} !important;
} 

body.theme-custom .v-icon.mdi-menu-down {
      color: ${theme.textColor} !important;
}


body.theme-custom .custom-select .v-input__control .v-input__slot .v-select__slot .v-label{
      color: #000 !important;
}

body.theme-custom .v-input input {
      color: ${theme.inputTextColor} !important;
}

body.theme-custom .container .v-application--is-ltr fieldset {
    background-color: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .container .v-btn--back {
      background-color: ${theme.cancelBtnColor} !important;
}

body.theme-custom .container .v-btn--return.v-btn--is-elevated.v-btn--has-bg {
      background-color: ${theme.sendBtnColor} !important;
}

body.theme-custom .container .v-application--wrap .v-slot--term .v-input__slot .v-label a {
      color: ${theme.textColor} !important;
}

body.theme-custom .v-input--selection-controls__input .v-icon {
      background-color: ${theme.textColor} !important;
}

body.theme-custom .container--fluid .btn-change {
      background-color: ${theme.changeBtnColor} !important;
      color: ${theme.btnTextColor} !important;
}

body.theme-custom .dialog {
    color: white !important;
    background-color: ${theme.backgroundColor} !important;
}

body.theme-custom .dialog fieldset {
    background: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .dialog .products-search {
    background-color: ${theme.backgroundColor} !important;
}

body.theme-custom .container .v-data-footer__select {
      color: ${theme.textColor} !important;
}

body.theme-custom .v-select .v-select__selections {
      color: ${theme.textColor} !important;
}

body.theme-custom .container .v-application--is-ltr .v-data-footer__pagination {
      color: ${theme.textColor} !important;
}

body.theme-custom .v-text-field--solo.v-select-return > .v-input__control > .v-input__slot {
    background: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .container--fluid .row:not(:last-child) {
    background-color: ${theme.inputBackgroundColor} !important;
}

body.theme-custom .v-radio .v-input--selection-controls__input .mdi:before {
    border: none !important;
    color: ${theme.textColor};
}

}</style> `;
    },
    verifyOrder() {
      if (this.selectedProducts.length == 0) {
        this.$router.push({
          path: '/',
          query: { shop: this.$store.state.shop, lang: this.$i18n.locale },
        });
      } else {
        return;
      }
    },

    ...mapActions([]),
    goBack: function () {
      this.$router.push({
        path: '/',
        query: { shop: this.$store.state.shop, lang: this.$i18n.locale },
      });
    },
  },
};
</script>

<style lang="scss">
.theme-blue,
.theme-green,
.theme-dark {
  .font-weight-light {
    color: #fff;
  }
}

.v-btn.v-btn--has-bg:not(.btn-anulat):not(.btn-return):not(.v-btn--back):not(.v-btn--disabled):not(.v-btn--return):not(
    .btn-change
  ) {
  background: #f7d523 !important;
  color: #1b254e !important;
}

.theme-white
  .v-btn.v-btn--has-bg:not(.btn-anulat):not(.btn-return):not(.v-btn--back):not(.v-btn--disabled):not(
    .v-btn--return
  ):not(.btn-change) {
  background: #f7d523 !important;
  color: #1b254e !important;
}
</style>
